// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2gbi2";
var _3 = "wrapper_arrowed-eUNez";
var _4 = "wrapper_business-2jC5M";
var _5 = "wrapper_active-Y43AD";
var _6 = "wrapper_economy-R-oaS";
var _7 = "wrapper_flat-1MKtI";
var _8 = "wrapper_singleFare-C53Qx";
var _9 = "titles-hd1FW";
var _a = "title-1ReIF";
var _b = "title_singleFare-Sgk3P";
var _c = "prefix-CA0Sw";
var _d = "prefix_singleFare-2GMLF";
var _e = "prefix_noSeats-1envR";
var _f = "price-3WMN7";
var _10 = "price_singleFare-2zKOy";
var _11 = "price__icon-3rUxb";
var _12 = "price_arrowed-13Lej";
var _13 = "price_RUB-2aH-O";
var _14 = "wrapper_disabled-13lmA";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_arrowed", _4 as "wrapper_business", _5 as "wrapper_active", _6 as "wrapper_economy", _7 as "wrapper_flat", _8 as "wrapper_singleFare", _9 as "titles", _a as "title", _b as "title_singleFare", _c as "prefix", _d as "prefix_singleFare", _e as "prefix_noSeats", _f as "price", _10 as "price_singleFare", _11 as "price__icon", _12 as "price_arrowed", _13 as "price_RUB", _14 as "wrapper_disabled" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_arrowed": _3, "wrapper_business": _4, "wrapper_active": _5, "wrapper_economy": _6, "wrapper_flat": _7, "wrapper_singleFare": _8, "titles": _9, "title": _a, "title_singleFare": _b, "prefix": _c, "prefix_singleFare": _d, "prefix_noSeats": _e, "price": _f, "price_singleFare": _10, "price__icon": _11, "price_arrowed": _12, "price_RUB": _13, "wrapper_disabled": _14 }
